export const FEATURE = 'clan_landing'

export const Actions = {
    Open: 'open',
    Close: 'close',
    Click: 'click',
    Preview: 'preview',
    Hover: 'hover',
    TooltipWatched: 'tooltip_watched',
}

export const Items = {
    Hangar: 'hangar',
    LandingPromo: 'landing_promo_window',
    LandingBonus: 'landing_bonus_window',
    LandingToursOfDuty: 'landing_tours_of_duty_window',
    LandingStronghold: 'landing_stronghold_window',
    LandingGlobalMap: 'landing_globalmap_window',
    LandingClans: 'landing_clans_window',
    LandingPromoStyleTooltip: 'landing_promo_style_tooltip',
    GlobalMapEventButton: 'global_map_event_button',
    LegionnaireBattleButton: 'legionnaire_battle_button',
    ClanInvitationsButton: 'clan_invitations_button',
    CreateClanButton: 'create_clan_button',
    FocusSearchTextField: 'focus_search_text_field',
    ClearSearchTextField: 'clear_search_text_field',
    SubmitSearchTextField: 'submit_search_text_field',
    FiltersSettingsWindow: 'filters_settings_window',
    ClanInfoCard: 'clan_info_card',
    PaginationLeftButton: 'pagination_left_button',
    PaginationRightButton: 'pagination_right_button',
    JoinClanButton: 'join_clan_button',
    SaveButton: 'save_button',
}


// WEBPACK FOOTER //
// ./containers/Landing/logConstants.js